import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getTypographyColorProps } from './getTypographyColorProps';
import { renderHeadingTextWithEmphasis } from './renderHeadingTextWithEmphasis';

const TitleUnderline = styled('span', {
  shouldForwardProp: (prop) =>
    !['underlineProp', 'uppercaseProp', 'underlineColor'].includes(prop),
})`
  @media screen and (min-width: 992px) {
    display: inline-block;
    ${({ underlineProp, underlineColor }) =>
      underlineProp
        ? `border-bottom: 2px dashed ${underlineColor};`
        : 'border-bottom: none;'}
    ${({ uppercaseProp }) =>
      uppercaseProp ? 'text-transform: uppercase;' : 'text-transform: none;'}
    font-size: 42px;
    line-height: 55px;
    font-weight: 700;
  }
  @media screen and (max-width: 991px) {
    display: inline-block;
    ${({ underlineProp, underlineColor }) =>
      underlineProp
        ? `border-bottom: 2px dashed ${underlineColor};`
        : 'border-bottom: none;'}
    ${({ uppercaseProp }) =>
      uppercaseProp ? 'text-transform: uppercase;' : 'text-transform: none;'}
    ${({ underlineProp }) =>
      underlineProp ? 'padding-bottom: 10px;' : 'padding-bottom: 0;'}
    font-size: 29px;
    line-height: 36.45px;
    font-weight: 600;
  }
  @media screen and (max-width: 400px) {
    display: inline-block;
    ${({ underlineProp, underlineColor }) =>
      underlineProp
        ? `border-bottom: 2px dashed ${underlineColor};`
        : 'border-bottom: none;'}
    ${({ uppercaseProp }) =>
      uppercaseProp ? 'text-transform: uppercase;' : 'text-transform: none;'}
    ${({ underlineProp }) =>
      underlineProp ? 'padding-bottom: 10px;' : 'padding-bottom: 0;'}
    font-size: 29px;
    line-height: 34.5px;
    font-weight: 600;
  }
`;

const Heading3 = (props) => {
  const underlineProp = Boolean(props.underline);
  const uppercaseProp = Boolean(props.uppercase);

  const {
    color,
    children,
    underline: _underline,
    uppercase: _uppercase,
    ...rest
  } = props;
  const { typographyColor, colorStyle } = getTypographyColorProps(color);
  const formattedChildren = renderHeadingTextWithEmphasis(children, color);
  return (
    <Typography
      {...rest}
      component="h3"
      color={typographyColor}
      sx={[
        {
          textAlign: 'center',
        },
        colorStyle,
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
      ]}
    >
      <TitleUnderline
        underlineProp={underlineProp}
        uppercaseProp={uppercaseProp}
        underlineColor={color || '#000'}
      >
        {formattedChildren}
      </TitleUnderline>
    </Typography>
  );
};

export default Heading3;
